import { AbstractTutorialHighlight } from "../../../../common_ui_elements/abstract_tutorial_highlight.js";
import { ColorScheme } from "../../../../common_ui_elements/color_scheme.js";
import { TextStyleScheme } from "../../../../common_ui_elements/text_style_scheme.js";
import { UINineSliceElement } from "../../../../common_ui_elements/ui_nine_slice_element.js";
import { MyTextAlign, MyTextVerticalAlign, UITextElement } from "../../../../common_ui_elements/ui_text_element.js";
import { ImgID } from "../../../../../image_loader/img_id.js";
import { NineSliceDictionary } from "../../../../../image_loader/nine_slicer/nine_slice_dictionary.js";

export class ShotsTutorialHighlight extends AbstractTutorialHighlight
{
  private static readonly DEFAULT_RADIUS_SCALE: number = 0.65;

  constructor( ctx: CanvasRenderingContext2D, width: number, height: number )
  {
    super( ctx, width, height );

    this.createSubstrate();
  }

  private createSubstrate(): void
  {
    const w = LayoutScaler.widthFromDesign( 779 );
    const h = LayoutScaler.heightFromDesign( 200 );
    const x = ( this.rect.getW() - w ) / 2;
    const y = LayoutScaler.yFromDesign( 300 );

    const substrate = new UINineSliceElement(
      this.ctx, x, y, w, h,
      ImgID.UI_TutorialSubstrate,
      NineSliceDictionary.values.tutorial_substrate
    );
    substrate.setClickable( false );

    this.addChild( substrate );

    const text_w = w * 0.9;
    const text_h = h * 0.9;

    const text = new UITextElement(
      this.ctx,
      ( w - text_w ) / 2,
      ( h - text_h ) / 2,
      text_w,
      text_h,
      {
        localization_key: "TUTORIAL.SECOND_TEXT",
        font_size: LayoutScaler.textSizeFromDesign( 45 ),
        font_weight: 900,
        text_color: ColorScheme.tutorial_text,
        text_style: TextStyleScheme.rubik,
        vertical_align: MyTextVerticalAlign.Center,
        text_align: MyTextAlign.Center,
        outline_color: ColorScheme.white,
        outline_width: LayoutScaler.textBorderSizeFromDesign( 5 ),
        shadow_offset_x: 0,
        shadow_offset_y: 0,
      }
    );

    substrate.addChild( text );
  }

  protected getDefaultRadiusScale(): number
  {
    return ShotsTutorialHighlight.DEFAULT_RADIUS_SCALE;
  }

  public name(): string
  {
    return "ShotsTutorialHighlight";
  }
}
